// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/dropify.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/dropify.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/dropify.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/dropify.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "#dropify" });
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
@font-face {
  font-family: 'dropify';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("svg");
  font-weight: normal;
  font-style: normal; 
}

.y7Nx7Cr1TtmW4ASo0VY5,
.y7Nx7Cr1TtmW4ASo0VY5 p,
.y7Nx7Cr1TtmW4ASo0VY5 span,
.y7Nx7Cr1TtmW4ASo0VY5 div,
.y7Nx7Cr1TtmW4ASo0VY5 label,
.y7Nx7Cr1TtmW4ASo0VY5 td,
.y7Nx7Cr1TtmW4ASo0VY5 th,
.y7Nx7Cr1TtmW4ASo0VY5 input,
.y7Nx7Cr1TtmW4ASo0VY5 textarea,
.y7Nx7Cr1TtmW4ASo0VY5 select {
  font-family: 'Titillium Web', sans-serif !important;
}

.OFUETHdzsKvxbfT4WVb3{
	padding: 0px 5px;
}

.qNhQVeyI1exxA1JZlPp2 {
    display: inline-block !important;
    height: auto !important;
    opacity: 1 !important;
    position: relative !important;
    pointer-events: auto !important;
    font-size: 14px !important;
    height: 26px !important;
    margin-bottom: 0 !important;
    border: none !important;
    border-bottom: 1px solid #9e9e9e !important;
    padding: 0 !important;
}

.BeWXtCxlJRELl3Y6jWRA{
    font-size: 14px !important;
    height: 26px !important;
    margin-bottom: 0 !important;
}

.GXlT2h5vFwCjkhqZ1txQ {
    font-weight: bold !important;
}

._2Ox8a9tL99eN3cfadyF {
    font-style: italic !important;
}

.HHT3NdpLsjB3wDdgFcyp {
    font-size: 15px;
}

.xB5kMpnFA4CZPws0ZB3v {
    font-size: 13px;
}

.Yd0yoKgLSxLwynjd1S4M {
    font-size: 14px;
}

.HHT3NdpLsjB3wDdgFcyp {
    font-size: 15px;
}

.ugBt4MGiOb2DFXqpRLyF {
    font-size: 16px;
}

.bw0PA147IW7666x4KZfn {
    font-size: 18px;
}

.De666OCGlMFmMIGbct1l {
    font-size: 20px;
}

.HsXLb9fWOQc7h8XdKMt9 {
    font-size: 22px;
}

.tsX3cXEfxB9qqcyeccJl{
    font-size: 24px;
}

.X_0vxuuWb7FuISJr5ta9 {
    background-color: var(--main-color-first) !important;
}

.xOz6IP2OVhytb_BEd_pa {
    color: var(--main-color-first) !important;
}

.Yssvoyks3Tt_18WYq6Bq {
    color: var(--main-color-text-first) !important;
}

.NBhOJ47WfZNMFovOLBIi {
    margin: 0 !important;
    padding: 0 !important;
}

.ESsTQs0NRD0m9VcdjFKY, .iSN2Ll6PzRlwvLTP3PoR{
    text-align: center;
    display: inline-block;
    width:100%;
}

.ESsTQs0NRD0m9VcdjFKY button {
    margin: 0 10px;
}

.iSN2Ll6PzRlwvLTP3PoR button {
    margin: 0 5px;
}


.B532rq_23Pe9TF1PjzKH{
    margin-right: 10px !important;
}

.oeb38Hm18558EJlE2mci{
    margin-left: 10px !important;
    cursor: pointer;
}

.SLQOkMmQUALpvE7my4r6 {
    display: inline-block;
    cursor: pointer;
}

.pvTKSJb26xmQWrNB4Fix {
    display: block;
    width: 100%;
    cursor: pointer;
}

.mBWaK0cEyX3MFXZ9pmmf {
    position: absolute;
    background: #3f3f3f;
    color: white;
    padding: 10px;
    border-radius: 4px;
    font-size: 15px;
    z-index: 99999999;
    width: max-content;
    opacity: 1;
    text-align: left;
    white-space: pre-line;
    line-height: 0.7;
}

/* globale pour cibler le popup du lien dans react-draft-wysiwyg */
.rdw-link-modal-target-option {
    display: none !important;
}

.dropify-wrapper input {
    height: 100% !important;
}

.LDD2Q5hgTlaPmQSzlqQ3 {
    text-transform: uppercase;
}

.wNEAJU9U4f26T_Ep3ahF {
    margin-bottom: 10px;
}


.uvPpKRpdDheJoB2hY8pN {
	display: flex;
	flex-direction: column;
	gap: 1rem;
	margin-top: 0.5rem;
	margin-bottom: 10px;
}

.G7D7wTAngTqCbg9pNxAW {
	width: 100%;
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 5px;
	background: #fafafa;
}

.G7D7wTAngTqCbg9pNxAW h4 {
	margin: 0;
	font-size: 16px;
}

.G7D7wTAngTqCbg9pNxAW ul {
	margin: 0.25rem 0 0.5rem;
	padding-left: 1.25rem;
}

.G7D7wTAngTqCbg9pNxAW code {
	background: #eee;
	padding: 0 0.2rem;
	border-radius: 3px;
	font-size: 0.9em;
}

.G7D7wTAngTqCbg9pNxAW .GWmKS3b4nw3SU10CODdw {
	font-size: 0.85em;
	color: #666;
	margin-top: 5px;
	margin-bottom: 5px;
}

.RO7C3xc9Tsu2g4SjrZ7W {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 0.4rem;
	margin-bottom: 0.5rem;
}

.e5qkYoonulG0mEX45eNg {
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 20px;
	color: var(--main-color-first);
}

.GNWuuLLiC3X7KKxSnb1Y{
    border: 1px dashed #aaa;
    border-radius: 8px;
    padding: 5px;
    text-align: center;
    cursor: pointer;
    background: #f9f9f9;
    position: relative;
    overflow: hidden;
}

.nfMcUJqu2Vi7HiUdofyL{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(200, 0, 0, 0.5);
    color: white;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px;
    font-weight: bold;
    transition: opacity 0.3s;
}

.g1HDSfwC2ycfLy92fA1f{
    font-family: 'dropify';
    color: rgb(125, 120, 120);
    font-size: 78px;
    font-style: normal;
    font-weight: normal;
    speak-as: none;
    display: inline-block;
    text-decoration: inherit;
    width: 1em;
    margin-left: .2em;
    margin-right: .2em;
    text-align: center;
    font-variant: normal;
    text-transform: none;
    line-height: 1em;
}

.g1HDSfwC2ycfLy92fA1f:before {
    content: '\\e801'; 
}

.kGJ3aN9tc9GrdRGRoD2s{
    position: absolute;
    color: rgb(81, 76, 76);
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
    margin-top: 10px;
    text-transform: uppercase;
    font-weight: bold;
    letter-spacing: -0.03em;
    font-size: 11px;
    width: 40px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.iZoBbCDEAkwwTbiaK2s4{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.8);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    border-radius: 5px;
    color: #fff;
    box-sizing: border-box;
}

.GGsFljecIpiwhsUp1qik{
    position: relative;       
    font-weight: bold;
    font-size: 13px;
    text-align: center;       
}

.TwnzWlAEr8_FfKVueZOw{
    height: 2px;
    background-color: #fff;
    margin: 5px 45%;
    width: 10%;
}

.ADJGusOp6Gg3HqDcnpkH{
    text-align: center;
    font-size: 12px;
    opacity: 0.5;
}

.gOtQRCmfawgWirtQturd{
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    color: #fff;
    border: 1px solid #fff;
    padding: 2px 6px;
    font-size: 12px;
    cursor: pointer;
    border-radius: 3px;
    transition: background 0.2s, color 0.2s;

}

.gOtQRCmfawgWirtQturd:hover{
    background-color: rgba(200, 200, 200, 0.3); 
    color: #fff; 
}

.nvCWSDX2_DZg0gokhnjO{
    width: 100%;
    margin-top: 10px;
}

.WESAR4jMpRrAWng01XH5{
    margin-bottom: 10px !important;
    text-transform: uppercase;
}

.UFyv3GYPGJ9NWKpEgM5D {
    display: flex;
    align-items: center;
    gap: 4px; /* espace entre les inputs */
}

.UFyv3GYPGJ9NWKpEgM5D input[type="color"]{
    width: 25px;
    padding: 0px;
    border:none;
}

.HQ8wAsiqfIbHQEBl8ynE{
    font-size: 14px !important;
    height: 26px !important;
    margin-bottom: 0 !important;
}

/* Tabs as buttons */
.Qu8WSNbuPEA3VUE0KoTp{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
}

.r1Oj_jrfoXY36ogdYUaX{
    padding: 8px 12px;
    border-radius: 4px;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 8px;
    transition: opacity 0.2s ease;
}

.y3_2JBurG6RHs77ajIZj{
    background-color: var(--main-color-first) !important;
    color: #ffffff !important;
}

.reQwrlnWK8rXoFECVyHx{
    background-color: #e7e7e7 !important;
    color: #373737 !important;
    border: 1px dotted grey;
}`, "",{"version":3,"sources":["webpack://./src/component/generale.module.css"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,sBAAsB;EACtB,4CAAgC;EAChC,mPAAkN;EAClN,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;;;;;;;;;;EAUE,mDAAmD;AACrD;;AAEA;CACC,gBAAgB;AACjB;;AAEA;IACI,gCAAgC;IAChC,uBAAuB;IACvB,qBAAqB;IACrB,6BAA6B;IAC7B,+BAA+B;IAC/B,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;IAC3B,uBAAuB;IACvB,2CAA2C;IAC3C,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,oDAAoD;AACxD;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,UAAU;AACd;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;AACjB;;;AAGA;IACI,6BAA6B;AACjC;;AAEA;IACI,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA,kEAAkE;AAClE;IACI,wBAAwB;AAC5B;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;CACC,aAAa;CACb,sBAAsB;CACtB,SAAS;CACT,kBAAkB;CAClB,mBAAmB;AACpB;;AAEA;CACC,WAAW;CACX,sBAAsB;CACtB,kBAAkB;CAClB,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,SAAS;CACT,eAAe;AAChB;;AAEA;CACC,wBAAwB;CACxB,qBAAqB;AACtB;;AAEA;CACC,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,iBAAiB;CACjB,WAAW;CACX,eAAe;CACf,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,WAAW;CACX,qBAAqB;AACtB;;AAEA;CACC,aAAa;CACb,uBAAuB;CACvB,mBAAmB;CACnB,eAAe;CACf,8BAA8B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,qBAAqB;IACrB,wBAAwB;IACxB,UAAU;IACV,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,QAAQ;IACR,SAAS;IACT,wCAAwC;IACxC,gCAAgC;IAChC,gBAAgB;IAChB,yBAAyB;IACzB,iBAAiB;IACjB,uBAAuB;IACvB,eAAe;IACf,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,kBAAkB;IAClB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,sBAAsB;IACtB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,kBAAkB;IAClB,uCAAuC;;AAE3C;;AAEA;IACI,0CAA0C;IAC1C,WAAW;AACf;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ,EAAE,4BAA4B;AAC1C;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,6BAA6B;AACjC;;AAEA;IACI,oDAAoD;IACpD,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,uBAAuB;AAC3B","sourcesContent":["@charset \"UTF-8\";\r\n@font-face {\r\n  font-family: 'dropify';\r\n  src: url(\"../fonts/dropify.eot\");\r\n  src: url(\"../fonts/dropify.eot#iefix\") format(\"embedded-opentype\"), url(\"../fonts/dropify.woff\") format(\"woff\"), url(\"../fonts/dropify.ttf\") format(\"truetype\"), url(\"../fonts/dropify.svg#dropify\") format(\"svg\");\r\n  font-weight: normal;\r\n  font-style: normal; \r\n}\r\n\r\n.familyFont,\r\n.familyFont p,\r\n.familyFont span,\r\n.familyFont div,\r\n.familyFont label,\r\n.familyFont td,\r\n.familyFont th,\r\n.familyFont input,\r\n.familyFont textarea,\r\n.familyFont select {\r\n  font-family: 'Titillium Web', sans-serif !important;\r\n}\r\n\r\n.bodygcd{\r\n\tpadding: 0px 5px;\r\n}\r\n\r\n.selectGeocd {\r\n    display: inline-block !important;\r\n    height: auto !important;\r\n    opacity: 1 !important;\r\n    position: relative !important;\r\n    pointer-events: auto !important;\r\n    font-size: 14px !important;\r\n    height: 26px !important;\r\n    margin-bottom: 0 !important;\r\n    border: none !important;\r\n    border-bottom: 1px solid #9e9e9e !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n.inputtGeocd{\r\n    font-size: 14px !important;\r\n    height: 26px !important;\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n.bold {\r\n    font-weight: bold !important;\r\n}\r\n\r\n.italic {\r\n    font-style: italic !important;\r\n}\r\n\r\n.fontSize15 {\r\n    font-size: 15px;\r\n}\r\n\r\n.fontSize13 {\r\n    font-size: 13px;\r\n}\r\n\r\n.fontSize14 {\r\n    font-size: 14px;\r\n}\r\n\r\n.fontSize15 {\r\n    font-size: 15px;\r\n}\r\n\r\n.fontSize16 {\r\n    font-size: 16px;\r\n}\r\n\r\n.fontSize18 {\r\n    font-size: 18px;\r\n}\r\n\r\n.fontSize20 {\r\n    font-size: 20px;\r\n}\r\n\r\n.fontSize22 {\r\n    font-size: 22px;\r\n}\r\n\r\n.fontSize24{\r\n    font-size: 24px;\r\n}\r\n\r\n.bgcolorfirst {\r\n    background-color: var(--main-color-first) !important;\r\n}\r\n\r\n.bgcolorfirsttext {\r\n    color: var(--main-color-first) !important;\r\n}\r\n\r\n.maincolorfirsttext {\r\n    color: var(--main-color-text-first) !important;\r\n}\r\n\r\n.noMargin {\r\n    margin: 0 !important;\r\n    padding: 0 !important;\r\n}\r\n\r\n.buttonfooter, .buttonfooterfrm{\r\n    text-align: center;\r\n    display: inline-block;\r\n    width:100%;\r\n}\r\n\r\n.buttonfooter button {\r\n    margin: 0 10px;\r\n}\r\n\r\n.buttonfooterfrm button {\r\n    margin: 0 5px;\r\n}\r\n\r\n\r\n.icomargin{\r\n    margin-right: 10px !important;\r\n}\r\n\r\n.icomarginObserv{\r\n    margin-left: 10px !important;\r\n    cursor: pointer;\r\n}\r\n\r\n.tooltipWrapper {\r\n    display: inline-block;\r\n    cursor: pointer;\r\n}\r\n\r\n.tooltipWrapperFull {\r\n    display: block;\r\n    width: 100%;\r\n    cursor: pointer;\r\n}\r\n\r\n.tooltipBubble {\r\n    position: absolute;\r\n    background: #3f3f3f;\r\n    color: white;\r\n    padding: 10px;\r\n    border-radius: 4px;\r\n    font-size: 15px;\r\n    z-index: 99999999;\r\n    width: max-content;\r\n    opacity: 1;\r\n    text-align: left;\r\n    white-space: pre-line;\r\n    line-height: 0.7;\r\n}\r\n\r\n/* globale pour cibler le popup du lien dans react-draft-wysiwyg */\r\n:global(.rdw-link-modal-target-option) {\r\n    display: none !important;\r\n}\r\n\r\n:global(.dropify-wrapper input) {\r\n    height: 100% !important;\r\n}\r\n\r\n.uppercase {\r\n    text-transform: uppercase;\r\n}\r\n\r\n.interbottom {\r\n    margin-bottom: 10px;\r\n}\r\n\r\n\r\n.geocoderHelpCards {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tgap: 1rem;\r\n\tmargin-top: 0.5rem;\r\n\tmargin-bottom: 10px;\r\n}\r\n\r\n.geocoderHelpCard {\r\n\twidth: 100%;\r\n\tborder: 1px solid #ddd;\r\n\tborder-radius: 4px;\r\n\tpadding: 5px;\r\n\tbackground: #fafafa;\r\n}\r\n\r\n.geocoderHelpCard h4 {\r\n\tmargin: 0;\r\n\tfont-size: 16px;\r\n}\r\n\r\n.geocoderHelpCard ul {\r\n\tmargin: 0.25rem 0 0.5rem;\r\n\tpadding-left: 1.25rem;\r\n}\r\n\r\n.geocoderHelpCard code {\r\n\tbackground: #eee;\r\n\tpadding: 0 0.2rem;\r\n\tborder-radius: 3px;\r\n\tfont-size: 0.9em;\r\n}\r\n\r\n.geocoderHelpCard .example {\r\n\tfont-size: 0.85em;\r\n\tcolor: #666;\r\n\tmargin-top: 5px;\r\n\tmargin-bottom: 5px;\r\n}\r\n\r\n.geocoderHelpHeader {\r\n\tdisplay: flex;\r\n\talign-items: center;\r\n\tjustify-content: center;\r\n\tgap: 0.4rem;\r\n\tmargin-bottom: 0.5rem;\r\n}\r\n\r\n.geocoderHelpIcon {\r\n\tdisplay: flex;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\tfont-size: 20px;\r\n\tcolor: var(--main-color-first);\r\n}\r\n\r\n.gcdUpForm{\r\n    border: 1px dashed #aaa;\r\n    border-radius: 8px;\r\n    padding: 5px;\r\n    text-align: center;\r\n    cursor: pointer;\r\n    background: #f9f9f9;\r\n    position: relative;\r\n    overflow: hidden;\r\n}\r\n\r\n.gcdErrorUp{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(200, 0, 0, 0.5);\r\n    color: white;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    transition: opacity 0.3s;\r\n}\r\n\r\n.gcdIconFile{\r\n    font-family: 'dropify';\r\n    color: rgb(125, 120, 120);\r\n    font-size: 78px;\r\n    font-style: normal;\r\n    font-weight: normal;\r\n    speak-as: none;\r\n    display: inline-block;\r\n    text-decoration: inherit;\r\n    width: 1em;\r\n    margin-left: .2em;\r\n    margin-right: .2em;\r\n    text-align: center;\r\n    font-variant: normal;\r\n    text-transform: none;\r\n    line-height: 1em;\r\n}\r\n\r\n.gcdIconFile:before {\r\n    content: '\\e801'; \r\n}\r\n\r\n.gcdIconFileText{\r\n    position: absolute;\r\n    color: rgb(81, 76, 76);\r\n    top: 50%;\r\n    left: 50%;\r\n    -webkit-transform: translate(-50%, -50%);\r\n    transform: translate(-50%, -50%);\r\n    margin-top: 10px;\r\n    text-transform: uppercase;\r\n    font-weight: bold;\r\n    letter-spacing: -0.03em;\r\n    font-size: 11px;\r\n    width: 40px;\r\n    white-space: nowrap;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n}\r\n\r\n.gcdHoveringUp{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100%;\r\n    height: 100%;\r\n    background-color: rgba(0,0,0,0.8);\r\n    display: flex;\r\n    flex-direction: column;\r\n    justify-content: space-between;\r\n    padding: 10px;\r\n    border-radius: 5px;\r\n    color: #fff;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.hoverTop{\r\n    position: relative;       \r\n    font-weight: bold;\r\n    font-size: 13px;\r\n    text-align: center;       \r\n}\r\n\r\n.hoverDivider{\r\n    height: 2px;\r\n    background-color: #fff;\r\n    margin: 5px 45%;\r\n    width: 10%;\r\n}\r\n\r\n.hoverBottom{\r\n    text-align: center;\r\n    font-size: 12px;\r\n    opacity: 0.5;\r\n}\r\n\r\n.gcdbtnHoveringUp{\r\n    position: absolute;\r\n    right: 0;\r\n    top: 50%;\r\n    transform: translateY(-50%);\r\n    background: none;\r\n    color: #fff;\r\n    border: 1px solid #fff;\r\n    padding: 2px 6px;\r\n    font-size: 12px;\r\n    cursor: pointer;\r\n    border-radius: 3px;\r\n    transition: background 0.2s, color 0.2s;\r\n\r\n}\r\n\r\n.gcdbtnHoveringUp:hover{\r\n    background-color: rgba(200, 200, 200, 0.3); \r\n    color: #fff; \r\n}\r\n\r\n.gcdbtnLaunch{\r\n    width: 100%;\r\n    margin-top: 10px;\r\n}\r\n\r\n.titleedsection{\r\n    margin-bottom: 10px !important;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.pickctn {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 4px; /* espace entre les inputs */\r\n}\r\n\r\n.pickctn input[type=\"color\"]{\r\n    width: 25px;\r\n    padding: 0px;\r\n    border:none;\r\n}\r\n\r\n.inputtCol{\r\n    font-size: 14px !important;\r\n    height: 26px !important;\r\n    margin-bottom: 0 !important;\r\n}\r\n\r\n/* Tabs as buttons */\r\n.tabsCtn{\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    gap: 10px;\r\n}\r\n\r\n.tabBtn{\r\n    padding: 8px 12px;\r\n    border-radius: 4px;\r\n    text-decoration: none;\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    transition: opacity 0.2s ease;\r\n}\r\n\r\n.tabBtnActive{\r\n    background-color: var(--main-color-first) !important;\r\n    color: #ffffff !important;\r\n}\r\n\r\n.tabBtnInactive{\r\n    background-color: #e7e7e7 !important;\r\n    color: #373737 !important;\r\n    border: 1px dotted grey;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"familyFont": `y7Nx7Cr1TtmW4ASo0VY5`,
	"bodygcd": `OFUETHdzsKvxbfT4WVb3`,
	"selectGeocd": `qNhQVeyI1exxA1JZlPp2`,
	"inputtGeocd": `BeWXtCxlJRELl3Y6jWRA`,
	"bold": `GXlT2h5vFwCjkhqZ1txQ`,
	"italic": `_2Ox8a9tL99eN3cfadyF`,
	"fontSize15": `HHT3NdpLsjB3wDdgFcyp`,
	"fontSize13": `xB5kMpnFA4CZPws0ZB3v`,
	"fontSize14": `Yd0yoKgLSxLwynjd1S4M`,
	"fontSize16": `ugBt4MGiOb2DFXqpRLyF`,
	"fontSize18": `bw0PA147IW7666x4KZfn`,
	"fontSize20": `De666OCGlMFmMIGbct1l`,
	"fontSize22": `HsXLb9fWOQc7h8XdKMt9`,
	"fontSize24": `tsX3cXEfxB9qqcyeccJl`,
	"bgcolorfirst": `X_0vxuuWb7FuISJr5ta9`,
	"bgcolorfirsttext": `xOz6IP2OVhytb_BEd_pa`,
	"maincolorfirsttext": `Yssvoyks3Tt_18WYq6Bq`,
	"noMargin": `NBhOJ47WfZNMFovOLBIi`,
	"buttonfooter": `ESsTQs0NRD0m9VcdjFKY`,
	"buttonfooterfrm": `iSN2Ll6PzRlwvLTP3PoR`,
	"icomargin": `B532rq_23Pe9TF1PjzKH`,
	"icomarginObserv": `oeb38Hm18558EJlE2mci`,
	"tooltipWrapper": `SLQOkMmQUALpvE7my4r6`,
	"tooltipWrapperFull": `pvTKSJb26xmQWrNB4Fix`,
	"tooltipBubble": `mBWaK0cEyX3MFXZ9pmmf`,
	"uppercase": `LDD2Q5hgTlaPmQSzlqQ3`,
	"interbottom": `wNEAJU9U4f26T_Ep3ahF`,
	"geocoderHelpCards": `uvPpKRpdDheJoB2hY8pN`,
	"geocoderHelpCard": `G7D7wTAngTqCbg9pNxAW`,
	"example": `GWmKS3b4nw3SU10CODdw`,
	"geocoderHelpHeader": `RO7C3xc9Tsu2g4SjrZ7W`,
	"geocoderHelpIcon": `e5qkYoonulG0mEX45eNg`,
	"gcdUpForm": `GNWuuLLiC3X7KKxSnb1Y`,
	"gcdErrorUp": `nfMcUJqu2Vi7HiUdofyL`,
	"gcdIconFile": `g1HDSfwC2ycfLy92fA1f`,
	"gcdIconFileText": `kGJ3aN9tc9GrdRGRoD2s`,
	"gcdHoveringUp": `iZoBbCDEAkwwTbiaK2s4`,
	"hoverTop": `GGsFljecIpiwhsUp1qik`,
	"hoverDivider": `TwnzWlAEr8_FfKVueZOw`,
	"hoverBottom": `ADJGusOp6Gg3HqDcnpkH`,
	"gcdbtnHoveringUp": `gOtQRCmfawgWirtQturd`,
	"gcdbtnLaunch": `nvCWSDX2_DZg0gokhnjO`,
	"titleedsection": `WESAR4jMpRrAWng01XH5`,
	"pickctn": `UFyv3GYPGJ9NWKpEgM5D`,
	"inputtCol": `HQ8wAsiqfIbHQEBl8ynE`,
	"tabsCtn": `Qu8WSNbuPEA3VUE0KoTp`,
	"tabBtn": `r1Oj_jrfoXY36ogdYUaX`,
	"tabBtnActive": `y3_2JBurG6RHs77ajIZj`,
	"tabBtnInactive": `reQwrlnWK8rXoFECVyHx`
};
export default ___CSS_LOADER_EXPORT___;
